import React, { memo } from 'react';
import cx from 'clsx';

import styles from './styles.module.css';

type InputProps = {
  name: string;
  label?: string;
  placeholder?: string;
  type?: React.HTMLInputTypeAttribute;
  onChange: (value: React.ChangeEvent<HTMLInputElement>) => void;
  value: string;
  error?: string;
};

export const Input: React.FC<InputProps> = memo(
  ({ name, label, placeholder = 'type...', type = 'text', onChange, value, error }) => {
    return (
      <div className={styles.container}>
        {label && (
          <label htmlFor={name} className={styles.label}>
            {label}
          </label>
        )}
        <input
          className={cx({
            [styles.input]: true,
            [styles.inputError]: !!error,
          })}
          id={name}
          name={name}
          type={type}
          placeholder={placeholder}
          onChange={onChange}
          value={value}
        />
        {error && <span className={styles.error}>{error}</span>}
      </div>
    );
  }
);
